export enum ApiQueries {
  PATIENT = 'PATIENT',
  DOCTORS = 'DOCTORS',
  PATIENT_RESULT = 'PATIENT_RESULT',
}
